
<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Proveedores</span>
	  		    <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small dark color="green"
              @click="exportExcel( proveedores  , 'proveedores_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="proveedores"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>

                  <template v-slot:item.documento="{ item }">
                    <div v-if="item.documento" class="d-flex">
                      <v-btn
                        x-small
                        color="light-blue darken-1"
                        @click="visualizarDocumento(item)"
                        class="mr-1"
                        title="Visualizar"
                        fab
                        elevation="2"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        x-small
                        color="green lighten-3"
                        @click="descargarDocumento(item)"
                        title="Descargar"
                        fab
                        elevation="2"
                      >
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                    </div>
                    <span v-else>-</span>
                  </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn
							    		color="primary"
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn
							    		color="error"
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>


							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idproveedores }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
          	<v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.nombre_comercial"
                label="Nombre comercial"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.titular"
                label="Titular"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

             <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.direccion"
                label="Dirección"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

             <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.clabe"
                label="Clabe"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

             <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.banco"
                label="Banco"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

             <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.telefono"
                label="Telefono"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.vendedor"
                label="Vendedor"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.tipo_insumos"
                label="Tipo de insumos"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="editedItem.notas"
                label="Notas"
                filled
                hide-details
                auto-grow
                rows="3"
              ></v-textarea>
            </v-col>

            <v-col cols="12">
              <v-file-input
                v-model="fileInput"
                label="Documento"
                filled
                hide-details
                dense
                prepend-icon="mdi-file-document"
                @change="handleFileUpload"
                :show-size="1000"
              ></v-file-input>
            </v-col>

            <!-- <v-col cols="12" sm="6" class="pt-0">
            	<v-switch
            		label="¿Activo Si/No?"
                hide-details
            		v-model="editedItem.activo_sn">
            	</v-switch>
            </v-col> -->

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <PDFViewer
      :dialog.sync="dialogPdf"
      :pdf-url="pdfUrl"
      :file-name="'documento-proveedor-' + (selectedProveedor ? selectedProveedor.idproveedores : '0') + '.pdf'"
    />

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import PDFViewer from '@/components/PDFViewer.vue';

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
      PDFViewer,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      dialogPdf: false,
      pdfUrl: null,
      selectedProveedor: null,

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      fileInput: null,

      dialog: false,
      dialogDelete: false,

      editedIndex: -1,

      editedItem: {
        idproveedores:0,
				nombre_comercial:'',
        titular:'',
				direccion:'',
				clabe:'',
        banco:'',
				telefono:'',
        vendedor:'',
        tipo_insumos:'',
        notas: '',
        documento: null,
        deleted:0,
      },

      defaultItem: {
        idproveedores:0,
				nombre_comercial:'',
        titular:'',
				direccion:'',
				clabe:'',
        banco:'',
				telefono:'',
        vendedor:'',
        tipo_insumos:'',
        notas: '',
        documento: null,
        deleted:0,
      },

      // Filtros:
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      proveedores: [],
      headers: [
        { text: 'ID'                   , value: 'idproveedores'    },
        { text: 'Nombre Comercial'     , value: 'nombre_comercial'},
        { text: 'Titular'              , value: 'titular'         },
        { text: 'Direccion'            , value: 'direccion'       },
        { text: 'Telefono'             , value: 'telefono'        },
        { text: 'Clabe'                , value: 'clabe'           },
        { text: 'Banco'                , value: 'banco'           },
        { text: 'Vendedor'             , value: 'vendedor'        },
        { text: 'Tipo de insumos'      , value: 'tipo_insumos'    },
        { text: 'Notas', value: 'notas' },
        { text: 'Documento', value: 'documento' },
        //{ text: 'Activo'        , value: 'activo_sn'       },
        { text: 'Actions'       , value: 'actions', sortable: false },

      ],
    }),

    computed: {
    	...mapGetters('login',['getCCNNUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Proveedor' : 'Editar Proveedor'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.proveedores = []
        return this.$http.get('proveedores.list.erp').then(response=>{
        	this.proveedores = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      handleFileUpload(file) {
        this.editedItem.documento = file || null;
      },


      editItem (item) {
        this.editedIndex = this.proveedores.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.fileInput = null;
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.proveedores.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem['deleted'] = 1
        this.$http.put('proveedores.update.erp/' + this.editedItem.idproveedores, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save() {
        if(this.editedItem.nombre_comercial == ''){
          this.validarErrorDirecto('Favor de llenar todos los campos requeridos')
          return;
        }

        this.cargar = true;

        // Creamos un FormData para enviar el archivo junto con los demás datos
        const formData = new FormData();

        // Añadimos todos los campos al formData
        for (const key in this.editedItem) {
          if (key === 'documento' && this.editedItem[key] instanceof File) {
            formData.append('files', this.editedItem[key]);
          } else {
            formData.append(key, this.editedItem[key]);
          }
        }

        // Configuración para enviar FormData
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };

        if (this.editedIndex > -1) {
          // Actualizar proveedor existente
          this.$http.post('proveedores.update.erp/' + this.editedItem.idproveedores, formData, config).then(response => {
            this.validarSuccess(response.data.message);
            this.initialize();
            this.close();
          }).catch(error => {
            this.validarError(error.response.data.message);
          }).finally(() => {
            this.cargar = false;
          });
        } else {
          // Crear nuevo proveedor
          this.$http.post('proveedores.add.erp', formData, config).then(response => {
            this.initialize();
            this.close();
          }).catch(error => {
            this.validarError(error.response.data.message);
          }).finally(() => {
            this.cargar = false;
          });
        }
      },
      descargarDocumento(item) {
        // Verificar que existe el ID del proveedor
        if (!item || !item.idproveedores) {
          this.validarErrorDirecto('No se puede descargar el documento: ID de proveedor no válido');
          return;
        }

        this.cargar = true;

        // Eliminar la barra diagonal extra al construir la URL
        let baseURL = this.$http.defaults.baseURL;

        // Si baseURL termina con /, quitamos la barra adicional
        if (baseURL.endsWith('/')) {
          baseURL = baseURL.slice(0, -1);
        }

        const url = `${baseURL}/proveedores.download.documento/${item.idproveedores}`;
        return
        console.log('URL de descarga:', url); // Para depuración

        // axios({
        //   url: url,
        //   method: 'GET',
        //   responseType: 'blob',
        // })
        // .then(response => {
        //   const blob = new Blob([response.data], { type: 'application/pdf' });
        //   const url = window.URL.createObjectURL(blob);

        //   const a = document.createElement('a');
        //   a.style.display = 'none';
        //   a.href = url;
        //   a.download = `documento-proveedor-${item.idproveedores}.pdf`;

        //   document.body.appendChild(a);
        //   a.click();

        //   window.URL.revokeObjectURL(url);
        //   document.body.removeChild(a);
        // })
        // .catch(error => {
        //   console.error('Error al descargar el documento:', error);
        //   this.validarError('Error al descargar el documento. Por favor, inténtelo de nuevo.');
        // })
        // .finally(() => {
        //   this.cargar = false;
        // });
      },
      visualizarDocumento(item) {
        if (!item || !item.idproveedores) {
          this.validarErrorDirecto('No se puede visualizar el documento: ID de proveedor no válido');
          return;
        }

        this.cargar = true;
        this.selectedProveedor = item;

        // Obtener la URL base
        let baseURL = this.$http.defaults.baseURL;
        if (baseURL.endsWith('/')) {
          baseURL = baseURL.slice(0, -1);
        }

        const url = `${baseURL}/proveedores.download.documento/${item.idproveedores}`;

        return
        // axios({
        //   url: url,
        //   method: 'GET',
        //   responseType: 'blob',
        // })
        // .then(response => {
        //   const blob = new Blob([response.data], { type: 'application/pdf' });
        //   this.pdfUrl = window.URL.createObjectURL(blob);
        //   this.dialogPdf = true;
        // })
        // .catch(error => {
        //   console.error('Error al cargar el documento:', error);
        //   this.validarError('Error al cargar el documento. Por favor, inténtelo de nuevo.');
        // })
        // .finally(() => {
        //   this.cargar = false;
        // });
      }
    },
  }
</script>


